// extracted by mini-css-extract-plugin
module.exports = {"courses-page":"courses-page_courses-page__gBh_w","course-list-with-navs":"courses-page_course-list-with-navs__MPiSs"};